import { render } from "./TripsList.vue?vue&type=template&id=a18d2170&scoped=true"
import script from "./TripsList.vue?vue&type=script&lang=js"
export * from "./TripsList.vue?vue&type=script&lang=js"

import "./TripsList.vue?vue&type=style&index=0&id=a18d2170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a18d2170"]])

export default __exports__